import React, { useEffect, useState, useContext } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Label } from "reactstrap";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/fontawesome-free-solid";
import EmailInput from "../../components/EmailBox/EmailBox";
import TextInput from "../../components/TextField/TextField";
import SelectBox from "../../components/SelectBox/SelectBox";
import PhoneNumberInput from "../../components/PhoneNumberBox/PhoneNumberBox";
import { Entry } from "../../redux/entrySlice";
import PasswordField from "../../components/PasswordField/PasswordField";
import MultipleFileUpload from "../../components/MultipleFileUpload/MultipleFileUpload";
import DatePickerComponent from "../../components/DatePicker/DatePicker";
import { TableContext } from "../../contexts/tableContext";
import styles from "./createUser.module.scss";
import { Container, Row, Col } from "react-bootstrap";
import {
  REACT_APP_API_ROLES_DROPDOWN,
  REACT_APP_API_FETCH_VENDOR,
  SERVER_URL,
  REACT_APP_API_FETCH_ZIPCODES,
  REACT_APP_API_VENDORS_LIST,
} from "../../redux/apiConstants";
import axios from "axios";
import LocationSelectBox from "../../components/LocationSelectBox/LocationSelectBox";
import TimePickerComponent from "../../components/TimePicker/TimePicker";

const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

function UserCreate() {
  const { dashboardStyle } = useContext(TableContext);
  const [submiting, setSubmitting] = useState(false);
  const { bodyStyle } = useContext(TableContext);
  const { formthemeStyle } = useContext(TableContext);
  const { setDashboardHeader } = useContext(TableContext);
  const { errormsgStyle } = useContext(TableContext);
  const [roles, setRoles] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [zipCodes, setZipCodes] = useState([]);

  const [text, setText] = useState();
  const [locations, setLocations] = useState([]);

  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [perror, setPerror] = useState(null);

  const [timings, setTimings] = useState([
    { dayOfWeek: "Monday", periods: [] },
    { dayOfWeek: "Tuesday", periods: [] },
    { dayOfWeek: "Wednesday", periods: [] },
    { dayOfWeek: "Thursday", periods: [] },
    { dayOfWeek: "Friday", periods: [] },
    { dayOfWeek: "Saturday", periods: [] },
    { dayOfWeek: "Sunday", periods: [] },
  ]);

  const parseTime24 = (time) => {
    if (!time) return null;
    const [hours, minutes, seconds] = time.split(":").map(Number);
    return hours * 3600 + minutes * 60 + (seconds || 0);
  };

  const handleTimingsChange = (dayIndex, periodIndex, type, value) => {
    setTimings((prevTimings) => {
      const updatedTimings = [...prevTimings];
      const period = updatedTimings[dayIndex].periods[periodIndex];
      
      if (type === "startLocalTime") {
        period.startLocalTime = value || "";
      } else if (type === "endLocalTime") {
        period.endLocalTime = value || "";
      }

      // Validation
      if (period.startLocalTime && period.endLocalTime) {
        const startSeconds = parseTime24(period.startLocalTime);
        const endSeconds = parseTime24(period.endLocalTime);
        
        if (startSeconds === endSeconds) {
          toast.error("Start time and End time cannot be the same.");
          period[type] = "";
          return updatedTimings;
        }

        // Check if end time is before start time (indicates next day)
        if (endSeconds < startSeconds) {
          period.isNextDay = true;
        } else {
          period.isNextDay = false;
        }
      }

      return updatedTimings;
    });
    return true;
  };

  const handleAddPeriod = (dayIndex) => {
    setTimings((prevTimings) => {
      const currentPeriods = prevTimings[dayIndex].periods;
      
      // Only validate if there are existing periods
      if (currentPeriods && currentPeriods.length > 0) {
        const hasInvalidPeriod = currentPeriods.some(p => 
          !p.startLocalTime || !p.endLocalTime
        );
        
        if (hasInvalidPeriod) {
          toast.error("Please complete the current period before adding a new one.");
          return prevTimings; // Don't add new period
        }
      }
      
      // Add new period
      const updatedTimings = [...prevTimings];
      updatedTimings[dayIndex] = {
        ...updatedTimings[dayIndex],
        periods: [...updatedTimings[dayIndex].periods, {
          startLocalTime: "",
          endLocalTime: "",
          isNextDay: false
        }]
      };
      return updatedTimings;
    });
  };

  const handleRemovePeriod = (dayIndex, periodIndex) => {
    setTimings((prevTimings) => {
      const updatedTimings = [...prevTimings];
      updatedTimings[dayIndex].periods.splice(periodIndex, 1);
      return updatedTimings;
    });
  };

  const getVendors = async () => {
    const vendorsList = await axios.get(REACT_APP_API_VENDORS_LIST);
    console.log("vendor list---", vendorsList.data?.data?.result);
    // const transformedVendors = vendorsList.data?.data?.result?.results?.map(
    //   (vendor) => ({
    //     value: vendor.id,
    //     label: vendor.name,
    //   })
    // );
    setVendors(vendorsList.data?.data?.result);
  };

  // const getZipCodes = async () => {
  //   const zipCodeList = await axios.get(REACT_APP_API_FETCH_ZIPCODES);
  //   console.log("zip code list", zipCodeList.data?.data?.result);
  //   const transformedZipCodes = zipCodeList.data?.data?.result?.map(
  //     (zipcode) => ({
  //       value: zipcode.zipCode,
  //       label: zipcode.zipCode,
  //     })
  //   );
  //   console.log(transformedZipCodes, "transformed zipcodes");
  //   setZipCodes(transformedZipCodes);
  // };

  const getLocation = async () => {
    try {
      const response = await axios.get(
        `${SERVER_URL}/location?location=${text}`
      );
      console.log("location-----", response.data);
      setLocations(response.data.data);
    } catch (error) {
      console.log("erroorrr--", error);
      console.error("Error fetching location:", error);
    }
  };
  useEffect(() => {
    getLocation();
  }, [text]);
  console.log(text, "text");

  useEffect(() => {
    window.scrollTo(0, 0);
    setDashboardHeader("Add Cafe Details");
    const url = REACT_APP_API_ROLES_DROPDOWN; // api url
    fetch(url)
      .then((resp) => resp.json()) // calling url by method GET
      .then((resp) => setRoles(resp.data.role.selectdata)); // setting response to state roles
    getVendors();
    getLocation();
    // getZipCodes();
  }, []);
  const dispatch = useDispatch();
  const { files } = useContext(TableContext);

  function convertToAMPM(timeString) {
    // Split the time string into hours and minutes
    const [hours, minutes] = timeString.split(":").map(Number);

    // Create a Date object with the given time
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);

    // Format the time in AM/PM format
    const formattedTime = date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    return formattedTime;
  }

  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  function onSubmitdata(data) {
    console.log("dataa--", data);

    setSubmitting(true);
    setError(null);

    // Format timings into an array
    const apiData = {
      name: data.name,
      description: data.description,
      // timings: JSON.stringify(timings),
      address: data.address,
      location_name: data.location_name.formatted_address,
      location: JSON.stringify(data.location_name.location),
      facebook: data.facebook,
      instagram: data.instagram,
      ccProcessingConfig: {
        percentage: data?.ccProcessingConfig?.percentage,
        fixedFee: data?.ccProcessingConfig?.fixedFee,
      },
      // vendor: data.Vendor,
      // zipCode: data.zipCode,
      File: files,
      timings: timings,
    };
    console.log("api data", apiData);
    data.actionUrl = "cafe";
    data.actionMethod = "post";
    data.apiData = apiData;
    dispatch(Entry(data)).then((resp) => {
      setSubmitting(false);
      if (resp.payload.code === 200) {
        navigate(-1);
      } else if (resp.payload.code === 401 || resp.payload.code === 400) {
        setError(resp.payload.message);
      } else {
        setError(resp?.payload?.message);
      }
    });
  }

  const handleLocationChange = async (value) => {
    setText(value);
  };

  return (
    <div className={styles[bodyStyle]}>
      <div
        className={styles[dashboardStyle]}
        style={{ minHeight: "100vh" }}
        id={styles.dashboardcont2}
      >
        <div className={styles[formthemeStyle]} id={styles.addform}>
          <FontAwesomeIcon
            icon={faArrowLeft}
            value="Back"
            onClick={() => {
              navigate(-1);
            }}
            className={styles.arrowback}
          />

          <div className="container-fluid mt-5">
            <form onSubmit={handleSubmit(onSubmitdata)}>
              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <TextInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Name"
                    fieldName="name"
                    placeHolder="Enter Name"
                    register={register}
                    errors={errors}
                    isRequired
                    mandatory
                  />
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <TextInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    maximLength={100}
                    label="Description"
                    placeHolder="Enter Description"
                    fieldName="description"
                    register={register}
                    errors={errors}
                    isRequired
                    mandatory
                  />
                </div>
              </div>

              <div className="row">
                {/* <div className="col-lg-6 col-md-12 col-sm-12">
                  <TimePickerComponent
                    control={control}
                    name="startTime"
                    isRequired={true}
                    errors={errors}
                    label="Start Time"
                    className="custom-timepicker"
                    mandatory
                  />
                  <TimePickerComponent
                    control={control}
                    name="endTime"
                    isRequired={true}
                    errors={errors}
                    label="End Time"
                    className="custom-timepicker"
                    mandatory
                  />
                </div> */}

                {/* {daysOfWeek.map((day) => (
                  <div className="col-lg-6 col-md-12 col-sm-12" key={day}>
                    <div className="form-group">
                      <label>{`${day} Start Time`}</label>
                      <TimePickerComponent
                        {...register(`${day.toLowerCase()}StartTime`, {
                          required: true,
                        })}
                        label={`${day} Start Time`}
                        errors={errors}
                        className="custom-timepicker"
                        // isRequired
                        control={control}
                      />
                      {errors[`${day.toLowerCase()}StartTime`] && (
                        <span>This field is required</span>
                      )}
                    </div>
                    <div className="form-group">
                      <label>{`${day} End Time`}</label>
                      <TimePickerComponent
                        {...register(`${day.toLowerCase()}EndTime`, {
                          required: true,
                        })}
                        label={`${day} End Time`}
                        errors={errors}
                        className="custom-timepicker"
                        // isRequired
                        control={control}
                      />
                      {errors[`${day.toLowerCase()}EndTime`] && (
                        <span>This field is required</span>
                      )}
                    </div>
                  </div>
                ))} */}

                {/* <div className="col-lg-6 col-md-12 col-sm-12">
                  <SelectBox
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    name="Vendor"
                    label="Vendor"
                    labelstyle={styles.formlabel}
                    control={control}
                    register={register}
                    values={vendors}
                    errors={errors}
                    placeholder="Choose Vendor"
                    mandatory
                    isRequired
                  />
                </div> */}

                <div className="col-lg-6 col-md-12 col-sm-12">
                  <LocationSelectBox
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    name="location_name"
                    label="Location (For GPS)"
                    labelstyle={styles.formlabel}
                    control={control}
                    register={register}
                    values={locations}
                    errors={errors}
                    placeholder="Choose Location"
                    mandatory
                    isRequired
                    setText
                    handleLocationChange={handleLocationChange}
                  />
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  {" "}
                  <TextInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Instagram"
                    placeHolder="Instagram"
                    fieldName="instagram"
                    register={register}
                    errors={errors}
                    // isRequired
                    // mandatory
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <TextInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Address"
                    placeHolder="Enter Address"
                    fieldName="address"
                    register={register}
                    errors={errors}
                    isRequired
                    mandatory
                  />
                  {/* <NumberInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Zip Code"
                    placeHolder="Enter Zip Code"
                    fieldName="zipCode"
                    register={register}
                    errors={errors}
                    isRequired
                    mandatory
                    minimLength={5}
                    maximLength={5} /> */}

                  {/* <SelectBox
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    name="zipCode"
                    label="Zip Code"
                    labelstyle={styles.formlabel}
                    control={control}
                    register={register}
                    values={zipCodes}
                    errors={errors}
                    placeholder="Choose ZipCode"
                    mandatory
                    isRequired
                  /> */}
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <TextInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Facebook"
                    placeHolder="Facebook"
                    fieldName="facebook"
                    register={register}
                    errors={errors}
                    // isRequired
                    // mandatory
                  />
                </div>
              </div>
              {/* cafe hours */}
              <div className="row">
                <h6 className={styles.heading}>Cafe Hours (24-hour format)</h6>
                {timings.map((timing, dayIndex) => (
                  <div key={timing.dayOfWeek} className="mb-3" style={{ border: "1px solid #e0e0e0", padding: "15px", borderRadius: "8px" }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="mb-0" style={{ fontWeight: "600", color: "#333" }}>
                        {timing.dayOfWeek}
                      </h6>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleAddPeriod(dayIndex);
                        }}
                        className="btn btn-sm"
                        style={{ 
                          backgroundColor: "#39979d", 
                          color: "white", 
                          padding: "5px 15px",
                          fontSize: "13px",
                          border: "none",
                          borderRadius: "4px"
                        }}
                      >
                        + Add Period
                      </button>
                    </div>
                    
                    {timing.periods.length === 0 ? (
                      <div style={{ textAlign: "center", color: "#999", padding: "20px 10px", fontSize: "13px" }}>
                        No hours set
                      </div>
                    ) : (
                      timing.periods.map((period, periodIndex) => (
                        <Container key={periodIndex} className="mb-2">
                          <Row className="align-items-center">
                            <Col md={1} className="text-center">
                              <small style={{ color: "#666" }}>Period {periodIndex + 1}</small>
                            </Col>
                            <Col md={4} className="text-center">
                              <TimePickerComponent
                                control={control}
                                name={`timings[${dayIndex}].periods[${periodIndex}].startLocalTime`}
                                errors={errors}
                                onTimeChange={(value) =>
                                  handleTimingsChange(dayIndex, periodIndex, "startLocalTime", value)
                                }
                              />
                            </Col>
                            <Col md={1} className="text-center">
                              <span style={{ fontWeight: "600" }}>-</span>
                            </Col>
                            <Col md={4} className="text-center">
                              <TimePickerComponent
                                control={control}
                                name={`timings[${dayIndex}].periods[${periodIndex}].endLocalTime`}
                                errors={errors}
                                onTimeChange={(value) =>
                                  handleTimingsChange(dayIndex, periodIndex, "endLocalTime", value)
                                }
                              />
                              {period.isNextDay && (
                                <div style={{ fontSize: "0.75rem", color: "#ff6b6b", marginTop: "4px" }}>
                                  Closes next day
                                </div>
                              )}
                            </Col>
                            <Col md={2} className="text-center">
                              <button
                                type="button"
                                onClick={() => handleRemovePeriod(dayIndex, periodIndex)}
                                className="btn btn-sm btn-danger"
                                style={{ padding: "5px 10px", fontSize: "12px" }}
                              >
                                Remove
                              </button>
                            </Col>
                          </Row>
                        </Container>
                      ))
                    )}
                  </div>
                ))}
              </div>

              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <p className={styles.formlabel}>Cover Image</p>
                  <MultipleFileUpload />
                </div>
              </div>
              {/* <div className="row mt-3">
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <MultipleFileUpload />
                  </div>
                </div> */}
              <div className="d-flex">
                <input
                  className={styles.formbtn}
                  type="submit"
                  disabled={submiting}
                  value={submiting ? "Please wait.." : "Submit"}
                />
                {/* <input
                  className={styles.resetbtn}
                  type="button"
                  value="Reset"
                  onClick={() => {
                    reset();
                  }}
                /> */}
              </div>
              <br />
              {error && (
                <h6
                  className={styles[errormsgStyle]}
                  style={{ float: "right" }}
                >
                  {error}
                </h6>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserCreate;
